import { css } from '@emotion/react';

type Variant = 'sent' | 'received';

export const getRootStyles = (variant: Variant) => css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  align-items: ${variant === 'sent' ? 'flex-end' : 'flex-start'};
`;

export const getOuterWrapperStyles = (variant: Variant) => css`
  display: flex;
  flex-direction: ${variant === 'sent' ? 'row-reverse' : 'row'};
  gap: var(--spacing-3);
  align-items: flex-start;
  width: 100%;
`;

export const avatarWrapperStyles = css`
  flex-shrink: 0;
`;

export const contentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  flex: 1;
  min-width: 0;
`;

export const getHeaderStyles = (variant: Variant) => css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-direction: ${variant === 'sent' ? 'row-reverse' : 'row'};
`;

export const getBubbleStyles = (variant: Variant) => css`
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-4);
  background-color: ${variant === 'sent'
    ? 'var(--color-neutral-900)'
    : 'var(--surface-neutral)'};
  color: ${variant === 'sent'
    ? 'var(--color-base-white)'
    : 'var(--text-primary)'};
  border: ${variant === 'sent' ? '1px solid transparent' : 'none'};
  border-top-left-radius: var(--radius-lg);
  border-top-right-radius: var(--radius-lg);
  border-bottom-left-radius: ${variant === 'sent' ? 'var(--radius-lg)' : '0'};
  border-bottom-right-radius: ${variant === 'sent' ? '0' : 'var(--radius-lg)'};
`;

export const getTimestampStyles = (variant: Variant) => css`
  text-align: ${variant === 'sent' ? 'right' : 'left'};
`;

export const contentStyles = css`
  flex: 1 1 auto;
  min-width: 1px;
  min-height: 1px;
  text-wrap: wrap;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
